import { Component, computed, inject, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';

import { UserOnboardingProfileDataStore } from '../../data-access/user-onboarding-profile.data-store';
import { MeasurementSystemDto } from '../../models/user-onboarding-modal.models';

interface MeasurementSystemOption {
  readonly value: MeasurementSystemDto;
  readonly label: string;
}

const MEASUREMENT_SYSTEM_OPTIONS: readonly MeasurementSystemOption[] = [
  { value: MeasurementSystemDto.Metric, label: 'Metric' },
  { value: MeasurementSystemDto.Imperial, label: 'Imperial' },
];

@Component({
  selector: 'tfs-user-onboarding-measurement-system',
  imports: [
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './user-onboarding-measurement-system.component.html',
  styleUrl: './user-onboarding-measurement-system.component.scss',
})
export class UserOnboardingMeasurementSystemComponent {
  private readonly snackBar = inject(MatSnackBar);
  private readonly profileDataStore = inject(UserOnboardingProfileDataStore);

  readonly next = output();

  protected readonly measurementSystemOptions = MEASUREMENT_SYSTEM_OPTIONS;
  protected readonly selectedMeasurementSystem = signal<MeasurementSystemDto | null>(null);
  protected readonly isSaving = this.profileDataStore.isLoading;
  protected readonly canSubmit = computed(
    () => this.selectedMeasurementSystem() !== null && !this.isSaving()
  );

  protected onNextClick(): void {
    const measurementSystem = this.selectedMeasurementSystem();
    if (!measurementSystem) return;

    this.profileDataStore.updateMeasurementSystem(measurementSystem).subscribe({
      next: () => this.next.emit(),
      error: () =>
        this.snackBar.open('Failed to update measurement system', 'Close', {
          duration: 4000,
          panelClass: 'error',
        }),
    });
  }
}
